export const categories = [
  { id: 1, name: "Branding", count: 7 },
  { id: 2, name: "Design", count: 15 },
  { id: 3, name: "Development", count: 3 },
  { id: 4, name: "Photography", count: 5 },
  { id: 5, name: "Other", count: 1 },
];
